'use strict';

var React = require('react');

var SvgAttachmentFilledIcon = function SvgAttachmentFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.666 9.677a4 4 0 0 0 0 5.657l.147.146a3.793 3.793 0 0 0 5.364 0 1 1 0 0 0-1.414-1.414c-.7.7-1.836.7-2.536 0l-.146-.146a2 2 0 0 1 0-2.829l5.015-5.015a1.993 1.993 0 1 1 2.819 2.82l-2.286 2.285a.567.567 0 1 1-.801-.801l2.25-2.25a1 1 0 1 0-1.414-1.415l-2.25 2.25a2.567 2.567 0 0 0 3.63 3.63l2.285-2.285a3.993 3.993 0 1 0-5.648-5.648l-5.015 5.015Z"
  }));
};
SvgAttachmentFilledIcon.displayName = "AttachmentFilledIcon";

exports.SvgAttachmentFilledIcon = SvgAttachmentFilledIcon;
